import { getPaletteColor } from 'pcln-design-system'
import React from 'react'
import { withTheme } from 'styled-components'
import { getVariationColors } from './colors'

const getPaletteColorFromTheme = (theme) => (shade) => {
  return getPaletteColor(shade)({ theme })
}

const withVariationColors = (Component) => {
  const WrappedComponent = ({ variation = 'vip', fillColor, theme, ...props }) => {
    const getShade = getPaletteColorFromTheme(theme)
    const { primaryColor, secondaryColor } = getVariationColors(variation)

    if (fillColor) {
      const isHexColor = fillColor.indexOf('#') !== -1
      return <Component fillColor={isHexColor ? fillColor : getShade(fillColor)} {...props} />
    }

    return <Component primaryColor={primaryColor} secondaryColor={secondaryColor} {...props} />
  }

  WrappedComponent.displayName = `withVariationColors(${Component.name})`

  return withTheme(WrappedComponent)
}

export default withVariationColors
